import { tokenSlice } from "../slice/tokenSlice";

const authApi = tokenSlice.injectEndpoints({
    endpoints: builder => ({

        //Post
        login: builder.mutation({
            query: credentials => ({
                url: 'Account/Login',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        msLogin: builder.mutation({
            query: credentials => ({
                url: 'Account/LoginMs',
                method: 'POST',
                body: credentials,
                // Add validation and error handling
                validateStatus: (response, result) => {
                    return response.status === 200 && result?.token?.accessToken;
                },
            }),
            // Add transform response if needed
            transformResponse: (response) => {
                if (!response?.token?.accessToken) {
                    throw new Error('Invalid response format');
                }
                return response;
            },
            // Add error handling
            transformErrorResponse: (response) => {
                return {
                    status: response.status,
                    message: response.data?.message || 'Login failed'
                };
            }
        }),
        register: builder.mutation({
            query: (register) => ({
                url: 'Account/Register',
                method: 'POST',
                body: register
            }),
            invalidatesTags: ['Authentication']
        }),
        updatePassword: builder.mutation({
            query: (params) => ({
                url: 'Account/UpdatePassword',
                method: 'POST',
                body: params
            }),
            invalidatesTags: ['Authentication']
        }),
        checkVerifyCode: builder.mutation({
            query: (params) => ({
                url: `Account/CheckVerifyCode`,
                method: 'POST',
                body: params
            }),
            invalidatesTags: ['Authentication']
        }),

        resetPassword: builder.mutation({
            query: (email) => ({
                url: `Account/SendResetPasswordEmail?email=${email}`,
                method: 'POST',
            }),
            invalidatesTags: ['Authentication'],
        }),

    })
})

export const { useLoginMutation, useMsLoginMutation, useRegisterMutation, useUpdatePasswordMutation, useCheckVerifyCodeMutation, useResetPasswordMutation, } = authApi

export { authApi }